import { Flex, Text } from '@chakra-ui/react';

import { LDFlags } from '../../constants/flags';
import { useFlag } from '../../hooks';
import { capitalizeWords } from '../../utils/strings';
import Button from '../ui/buttons/Button';

const ReferralBanner = ({
  referrerFn,
  referralCode,
  setReferralDetailsOpen,
}: {
  referrerFn: string | null;
  referralCode: string | null;
  setReferralDetailsOpen: (val: boolean) => void;
}) => {
  const comReferralProgram = useFlag(LDFlags.COM_REFERRAL_PROGRAM);
  if (!comReferralProgram) {
    return null;
  }
  return (
    <Flex
      bg="leaseEndBlue"
      color="white"
      py={2}
      fontSize={15}
      fontWeight={600}
      w="100%"
      mx="auto"
      position="relative"
      zIndex="1"
      justifyContent="center"
    >
      <Flex maxW="800px" mx="auto" justifyContent="center" alignItems="center" gap={4}>
        <Text as="span">
          {referrerFn
            ? `Ending Your Lease with ${capitalizeWords(referrerFn)}'s Referral`
            : `Ending Your Lease with a Referral`}
        </Text>
        <Text fontWeight={400} as="span">
          {referralCode ?? ''}
        </Text>
        <Button
          color="white"
          bg="oceanBoatBlue"
          py={0}
          px={4}
          fontWeight={500}
          letterSpacing={0}
          borderRadius={99}
          fontSize={12}
          _hover={{
            bg: 'oceanBoatBlue',
            opacity: '0.8',
          }}
          onClick={() => setReferralDetailsOpen(true)}
        >
          Details
        </Button>
      </Flex>
    </Flex>
  );
};
export default ReferralBanner;
